const renderSettingsTable = ({}: any) => {
    return <></>;
};

export default renderSettingsTable;
